import React, { useState, useRef } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

const FormControlSearch = ({
  size,
  id,
  setIsPopupOpen,
  className,
  placeholder,
  onChange,
  onKeyPress,
  screen,
  onClearText,
  clearSearchValue,
  ...rest
}) => {
  const [showClear, setShowClear] = useState(false);
  const inputElem = useRef(null);
  const onClear = () => {
    if (!onClearText) {
      inputElem.current.value = "";
      onChange({
        target: {
          value: "",
        },
      });
      setShowClear(false);
      if (screen === "mapper" && setIsPopupOpen) {
        setIsPopupOpen(false);
      }
    } else {
      onClearText();
      inputElem.current.value = "";
      onChange({
        target: {
          value: "",
        },
      });
      setShowClear(false);
    }
  };
  if (clearSearchValue) {
    inputElem.current.value = "";
  }
  const buttonClass =
    screen === "plan-group-home"
      ? "close-button-pg"
      : screen === "manage-fee-page"
      ? "manage-fee-page"
      : "close-button-wrapper" || "sponsor-employee"
      ? "close-button-sponsor"
      : "close-button-wrapper";
  const iconClass =
    screen === "plan-group-home" || "sponsor-employee"
      ? "icon-size"
      : "close-button" || "sponsor-employee"
      ? "icon-size"
      : "close-button";
  const onMouseMove = () => {
    if (inputElem.current.value) {
      setShowClear(true);
    }
  };
  const onMouseOut = () => {
    setShowClear(false);
  };
  const handleChange = (e) => {
    e.preventDefault();
    if (inputElem.current.value) {
      setShowClear(true);
    } else {
      setShowClear(false);
    }
    onChange(e);
  };

  const Width = screen === "payroll-listing" ? "600px" : (screen === "communication" ? "150px" : "");

  const closeButtonWrapperClass = inputElem?.current?.value ? "active" : "";
  return (
    <div className="form-control-seach-text pr-2" style={{ width: Width }}>
      <Form.Control
        ref={inputElem}
        {...rest}
        size={size}
        id={id}
        className={className}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyPress={onKeyPress}
        onFocus={onMouseOut}
        type="input"
      />
      <div
        className={`${buttonClass} ${closeButtonWrapperClass}`}
        onMouseMove={onMouseMove}
      >
        <button
          className={iconClass}
          type="button"
          onClick={onClear}
          style={{ marginLeft: "5.5rem" }}
        >
          <FontAwesomeIcon
            icon={faTimes}
            size={size || "2x"}
            style={
              screen == "mapper"
                ? {
                    marginLeft: "100px",
                    fontSize: "24px",
                    marginTop: "5px",
                  }
                : screen == "mapper-source-search"
                ? { marginLeft: "50px" }
                : {}
            }
          />
        </button>
      </div>
    </div>
  );
};

export default FormControlSearch;
